<template>
    <v-container class="px-0">
        <v-row v-if="itemsQuiz.length==0 && roleName=='Student'" justify="center" class="font-weight-bold">{{$t('noAssessment')}}</v-row>
        <v-row v-else-if="itemsQuiz.length>0 && roleName=='Student'" justify="center" class="font-weight-bold">{{$t('availableAssessment')}}</v-row>
        <v-row justify="center" v-if="roleName=='Student'">
            <v-col cols="12" sm="6" md="4" v-for="item in itemsQuiz" :key="item.quizTopicId">
                <v-card :style="{ background: `linear-gradient(135deg, ${getRandomColor(item.quizTopicId)}, ${getRandomColor(item.quizTopicId + 5)})` }" dark shaped elevation="10" class="quiz-card">
                    <v-card-text class="pb-0">
                        <p class="title text--primary">{{item.quizTitle}}</p>
                    </v-card-text>
                    <v-list class="pa-0">
                        <v-list-item class="py-0">
                            <v-list-item-icon><v-icon>timer</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ $t('time') }}</v-list-item-title>
                            <v-list-item-title>{{item.quizTime==0?'':item.quizTime+' minutes'}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="py-0">
                            <v-list-item-icon><v-icon>grade</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ $t('marks') }}</v-list-item-title>
                            <v-list-item-title>{{item.quizTotalMarks==0?'':item.quizTotalMarks}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item class="py-0">
                            <v-list-item-icon><v-icon>help</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ $t('questions') }}</v-list-item-title>
                            <!-- <v-list-item-title>{{item.questionsCount}}</v-list-item-title> -->
                             <v-list-item-title>{{item.numberOfQuestions}}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn 
                            class="white--text text-uppercase px-4" 
                            color="indigo darken-2" 
                            @click="initializeInstruction(item)"
                            :disabled="item.numberOfQuestions <= 0 || item.questionsCount <= 0"
                            elevation="5"
                            >
                            <v-icon left>mdi-play</v-icon>
                            {{ $t('start') }}
                        </v-btn>
                    </v-card-actions>                   
                </v-card>
            </v-col>
        </v-row>
        <v-row v-if="roleName=='Admin'">
            <v-col class="pl-2" cols="12" sm="6" md="3">
                <v-card :to="{name:'Users'}" class="dashboard-card elevation-10" :style="{ background: 'linear-gradient(135deg, #42A5F5, #1976D2)' }">
                <v-card-title>
                    <v-icon x-large left color="white">{{this.userIcon}}</v-icon>       
                </v-card-title>
                <v-card-text>{{$t('candidate')}} <span class="white--text font-weight-bold">{{totalStudents}}</span></v-card-text>
                </v-card>
            </v-col>
            <v-col class="pl-2" cols="12" sm="6" md="3">
                <v-card :to="{name:'QuizTopics'}" class="dashboard-card elevation-10" :style="{ background: 'linear-gradient(135deg, #64B5F6, #2196F3)' }">
                <v-card-title>
                    <v-icon x-large left color="white">{{this.assessIcon}}</v-icon>       
                </v-card-title>
                <v-card-text>{{$t('assess')}} <span class="white--text font-weight-bold">{{totalQuizes}}</span></v-card-text>
                </v-card>
            </v-col>
            <v-col class="pl-2" cols="12" sm="6" md="3">
                <v-card :to="{name:'QuizTopics'}" class="dashboard-card elevation-10" :style="{ background: 'linear-gradient(135deg, #90CAF9, #42A5F5)' }">
                <v-card-title>
                    <v-icon x-large left color="white">{{this.assessIcon}}</v-icon>       
                </v-card-title>
                <v-card-text>{{$t('liveAssess')}} <span class="white--text font-weight-bold">{{liveQuizes}}</span></v-card-text>
                </v-card>
            </v-col>
            <v-col class="pl-2" cols="12" sm="6" md="3">
                <v-card :to="{name:'Quizes'}" class="dashboard-card elevation-10" :style="{ background: 'linear-gradient(135deg, #0D47A1, #1565C0)' }">
                <v-card-title>
                    <v-icon x-large left color="white">{{this.questionIcon}}</v-icon>       
                </v-card-title>
                <v-card-text>{{$t('question')}} <span class="white--text font-weight-bold">{{totalQuestions}}</span></v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >      
                <v-card>
                    <v-toolbar
                        dark                       
                    >
                        <v-btn
                            icon
                            dark
                            @click="dialog = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>{{$t('instructions')}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn                          
                            text
                            class="text-capitalize"
                            @click="continueQuiz()"
                            >
                            <h3>{{$t('continue')}}</h3> 
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-timeline align-top dense>
                        <v-timeline-item small dark v-for="item in itemsInstruction" :key="item.instructionId">
                            {{item.description}}
                        </v-timeline-item>
                    </v-timeline>
                </v-card>        
            </v-dialog>
        </v-row>
        <Analytics class="pa-0" v-if="roleName=='Admin'" :chartColors="chartColors"/>
    </v-container>
</template>

<script>
import config from '../../../public/config'
import Analytics from '../../components/common/Analytics'

export default {
    name:'Dashboard',
    components:{
        Analytics,
    },
    data(){
        return{           
            itemsQuiz:[],  
            itemsInstruction:[],
            userInfo:{},
            totalStudents:'',
            totalQuizes:'',
            liveQuizes:'',
            totalQuestions:'',
            userId:null,
            dialog:false ,
            notifications:false,
            userIcon:'',
            assessIcon:'',
            questionIcon:'',
            chartColors: [
                '#0D47A1', '#1565C0', '#1976D2', '#1E88E5', '#2196F3',
                '#42A5F5', '#64B5F6', '#90CAF9', '#BBDEFB', '#E3F2FD',
                '#0277BD', '#0288D1', '#039BE5', '#03A9F4', '#29B6F6'
            ],
            gradientColors: {
                blue: ['rgba(33, 150, 243, 0.8)', 'rgba(33, 150, 243, 0.2)'],
                green: ['rgba(25, 118, 210, 0.8)', 'rgba(25, 118, 210, 0.2)'],
                orange: ['rgba(3, 169, 244, 0.8)', 'rgba(3, 169, 244, 0.2)'],
                red: ['rgba(66, 165, 245, 0.8)', 'rgba(66, 165, 245, 0.2)'],
                purple: ['rgba(13, 71, 161, 0.8)', 'rgba(13, 71, 161, 0.2)']
            }                    
        }
    },
    methods:{
        fetchMenus(){
            this.$store.dispatch('menu/fetchMenu')
            .then((response)=>{
                this.userIcon=response.data[3].iconClass
                this.assessIcon=response.data[5].iconClass
                this.questionIcon=response.data[6].iconClass
            })
            .catch((err)=>{
                console.log(err)
            })
        },
        getRandomColor(seed) {
            const colors = [
                '#0D47A1', '#1565C0', '#1976D2', '#1E88E5', '#2196F3', 
                '#42A5F5', '#64B5F6', '#90CAF9', '#BBDEFB', '#E3F2FD',
                '#0277BD', '#0288D1', '#039BE5', '#03A9F4', '#29B6F6'
            ];
            return colors[seed % colors.length];
        },
        initializeStudent(){
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('dashboard/fetchLiveQuizes',this.userInfo.email)
            .then((response)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                this.itemsQuiz=response.data
            })
            .catch((err)=>{
                console.log(err)
                this.$router.push({name:'NoInternet'})
            })
        },
        initializeAdmin(){
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('dashboard/fetchSummary')
            .then((response)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                if(response.status==200){
                    this.totalStudents=response.data.totalStudents
                    this.totalQuizes=response.data.totalQuizes
                    this.liveQuizes=response.data.liveQuizes
                    this.totalQuestions=response.data.totalQuestions
                }
            })
            .catch((err)=>{
                console.log(err)
                this.$router.push({name:'NoInternet'})
            })
        },
        initializeInstruction(item){
            this.$store.dispatch('dashboard/applyLoading')
            this.$store.dispatch('settings/fetchInstructions',item.quizTopicId)
            .then((response)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                if(response.data.length>0){
                    this.dialog=true
                    this.itemsInstruction=response.data
                    this.$store.dispatch('quiz/storeSingleQuiz',item)
                }else{
                    this.startQuiz(item)
                }              
            })
            .catch((err)=>{
                console.log(err)
            })
        },
        startQuiz(item){
            if (item.numberOfQuestions <= 0) {
                this.$root.$emit('message_from_parent_long', this.$t('noQuestions'));
                return;
            }
            this.$store.dispatch('dashboard/applyLoading')
            const objResponseInitial={
                userId:parseInt(localStorage.getItem('loggedUserId')),
                email:this.userInfo.email,
                quizTopicId:item.quizTopicId,
                quizTitle:item.quizTitle,
                quizMark:item.quizTotalMarks,
                quizPassMarks:item.quizPassMarks,
                quizTime:item.quizTime,
                addedBy:parseInt(localStorage.getItem('loggedUserId'))
            }
            this.$store.dispatch('dashboard/createInitialResponse',objResponseInitial)
            .then((response)=>{
                this.$store.dispatch('dashboard/cancelLoading')
                if(response.status==200){
                    this.$store.dispatch('dashboard/startQuiz',item)
                    this.$store.dispatch('dashboard/saveQuizLiveTime',item.quizTime)
                    if(item.allowExamOnNewWindow){
                        this.initializeStudent()
                        this.$store.dispatch('dashboard/changeVisibility')
                        window.open(window.location.origin+'/quiz/startQuiz','','width='+window.outerWidth+', height='+window.outerHeight)
                    }else{
                        this.$router.push({name:'StartQuiz'})
                    } 
                }else if(response.status==202){
                    this.$root.$emit('message_from_parent_long',this.$t(response.data.responseMsg))
                    if(response.data.status!='alert'){
                        this.$root.$emit('message_for_renew_plan',this.$t('totalAttemptLimitExpired'))
                    }
                }
            })
        },
        continueQuiz(){
            this.dialog=false
            this.startQuiz(this.$store.getters['quiz/singleQuiz'])
        },
        makeRenewal(){
            var url = new URL(window.location.href);
            var renewId = url.searchParams.get('renew_id')
            if(renewId){
                var stripeUniqueId=renewId.replace(/{|}/g,'')
                fetch(config.hostname+'/checkout-session?sessionId='+stripeUniqueId)
                .then(response => response.json())
                .then(data=>{
                        if(data.id==stripeUniqueId && data.paymentStatus=='paid'){
                            const objNewPlan={
                                addedBy:this.userInfo.userId,
                                transactionEmail:data.customerDetails.email,
                                userEmail:this.userInfo.email,
                                stripeSessionId:stripeUniqueId,
                                billingPlanId:localStorage.getItem('billingPlanId'),
                                paymentMode:'Online',
                                transactionDetail:stripeUniqueId
                            }
                            this.$store.dispatch('user/updateBillingPlan',objNewPlan)
                            .then((response)=>{
                                if(response.status==200){
                                    this.$router.push({name:'Landing'})
                                    this.$root.$emit('message_from_parent_long',this.$t('billingPlanRenewalSuccess'))                     
                                }
                            })
                            .catch((err)=>{
                                console.log(err)
                            })                         
                        }
                    }
                )
                .catch(function (err) {
                    console.log('Error when fetching Checkout session', err);
                    this.$router.push({name:'NoInternet'})
                });
            }
        },
        getBackgroundColors(data) {
            if (!data || !Array.isArray(data)) return ['#2196F3'];
            return data.map((_, index) => this.chartColors[index % this.chartColors.length]);
        }
    },
    computed:{   
        roleName(){
            return this.userInfo.roleName
        }    
    },
    created(){
        this.userInfo=this.$store.getters['dashboard/userInfo']
        this.$store.dispatch('dashboard/changeVisibility')
        this.$store.dispatch('dashboard/saveQuestionSerial',0)
        this.$store.dispatch('dashboard/saveSerialToShow',1)
        this.$store.dispatch('dashboard/saveQuizFlag',false)
        this.fetchMenus()
        if(this.userInfo.roleName=='Student'){    
            this.makeRenewal()  
            this.initializeStudent()
        }else if(this.userInfo.roleName=='Admin'){
            this.initializeAdmin()
        }
    }
}
</script>

<style scoped>
.quiz-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
}

.quiz-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.dashboard-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  color: white;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}

.v-card-title {
  font-weight: bold;
}

.v-card-text {
  font-size: 1.1rem;
}

.v-card-text span.black--text {
  font-size: 1.5rem;
  font-weight: bold;
  color: white !important;
}
</style>